module.exports = __webpack_public_path__ + "img/vue.9405b997.svg";